<template>
  <div class="footer-container">
    <div class="button-container">
      <button
        class="boton boton-menos"
        :disabled="isGoBackDisabled"
        @click="goBack"
      >
        .
      </button>
      <span :class="image ? 'span-image' : 'span' ">Página {{ actualPage }} de {{ getTotalPages }}</span>
      <button
        class="boton boton-mas"
        :disabled="isGoForwardDisabled"
        @click="goForward"
      >
        .
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

export default {
  props: {
    totalPages: {
      type: Number,
      default: 1,
    },
    fatherPage: {
      type: Number,
      default: null,
    },
    image:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      actualPage: 1,
      isGoForwardDisabled: false,
      isGoBackDisabled: false,
    };
  },
  emits: ["paginationData"],
  computed: {
    getTotalPages() {
      if (this.actualPage <= 1) {
        this.isGoBackDisabled = true;
      } else {
        this.isGoBackDisabled = false;
      }
      if (this.totalPages === this.actualPage) {
        this.isGoForwardDisabled = true;
      } else {
        this.isGoForwardDisabled = false;
      }
      return this.totalPages;
    },
    // getPageCounter(){
    //   return this.actualPage
    // }
  },
  methods: {
    goForward() {
      if (this.actualPage === this.getTotalPages) {
        this.isGoForwardDisabled = true;
      }

      if (this.actualPage > 1) this.isGoBackDisabled = false;

      this.actualPage += 1;

      this.$emit("paginationData", this.actualPage);
    },
    goBack() {
      if (this.actualPage !== this.getTotalPages)
        this.isGoForwardDisabled = false;
      if (this.actualPage === 1) this.isGoBackDisabled = true;

      this.actualPage -= 1;

      this.$emit("paginationData", this.actualPage);
    },
  },
  watch: {
    fatherPage(value) {
      if (value !== this.actualPage) this.actualPage = 1;
    },
  },
};
</script>

<style scoped>
.footer-container {
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: center;
  align-content: center;
  justify-content: center;
  padding-top: 12px;
  padding-bottom: 12px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.boton {
  width: 26px;
  height: 25px;
  background-color: #fff;
  border-radius: 6px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0);
}

.boton-mas {
  background-image: url("../../../assets/imgs/Arrow.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px;
  border: 0;
  transform: matrix(0, -1, 1, 0, 0, 0);
}

.boton-menos {
  background-image: url("../../../assets/imgs/Arrow.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 12px;
  border: 0;
  transform: matrix(0, 1, -1, 0, 0, 0);
}

.boton-menos:disabled {
  filter: grayscale(100%);
  opacity: 0.5;
}

.boton-mas:disabled {
  filter: grayscale(100%);
  opacity: 0.5;
}

.span {
  font: normal normal normal 14px/19px Open Sans;
  color: #616161;
  margin-left: 7px;
  margin-right: 7px;
}

.span-image {
  font: normal normal normal 14px/19px Open Sans;
  color: #616161;
  margin-left: 7px;
  margin-right: 7px;
}

@media screen and (max-width: 767px) {
  .span-image {
  font: normal normal normal 10px/19px Open Sans;
  margin-left: 6px;
  margin-right: 6px;
}
}
</style>
